import React from 'react';
import { Box, Heading, Text, VStack, SimpleGrid, Button, Flex } from '@chakra-ui/react';
import { FaHome, FaClipboardList, FaWallet, FaChartLine, FaBell, FaExchangeAlt, FaCog, FaShoppingBasket } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const products = [
  {
    productName: 'Product 1',
    price: 10,
    description: 'Description for Product 1',
    quantityInStock: 20,
  },
  {
    productName: 'Product 2',
    price: 15,
    description: 'Description for Product 2',
    quantityInStock: 30,
  },
  // Add more products here
];

const RestaurantMarketPlace = () => {
  const handleRequestStock = () => {
    // Handle the request stock logic here
  };

  return (
    <Box bg="gray.50" p={8}>
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200">Market Place</Heading>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
        {products.map((product, index) => (
          <Box
            key={index}
            bg="white"
            p={4}
            borderRadius="xl" // Border radius of 45
            boxShadow="md"
            transition="transform 0.2s ease-in-out" // Transition for hover effect
            _hover={{ transform: 'translateY(-5px)' }} // Hover effect
          >
            <VStack spacing={2}>
              <Text color="blue.200" fontWeight="bold">
                {product.productName}
              </Text>
              <Text color="blue.200">Price: ${product.price.toFixed(2)}</Text>
              <Text color="blue.200">Stock: {product.quantityInStock}</Text>
              <Text color="blue.200">{product.description}</Text>
            </VStack>
          </Box>
        ))}
      </SimpleGrid>

      <Box mt={4}>
        <Heading color="blue.200" mb={2}>
          Request Stock
        </Heading>
        <Text color="blue.200" mb={4}>
          If you need to request stock for specific products, you can use the button below.
        </Text>
        <Button colorScheme="blue" onClick={handleRequestStock}>
          Request Stock
        </Button>
      </Box>
            {/* Bottom Navigation for Mobile */}
            <Flex
          bg="blue.200"
          p={2}
          mt={4}
          align="center"
          justify="space-between"
          position="fixed"
          bottom={0}
          mx="auto"
          width="95%"
          display={{ base: 'flex', md: 'none' }} // Hide on larger screens
        >
            <Box textAlign="center" flex="1" p={2}>
              <Link to="restaurant">
                  <Flex alignItems="center" flexDirection="column">
                  <FaHome />
                  <Text color="white" fontSize="xs" mt={1}>
                      Home
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-orders">
                  <Flex alignItems="center" flexDirection="column">
                  <FaClipboardList />
                  <Text color="white" fontSize="xs" mt={1}>
                      Orders
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-market-place">
                  <Flex alignItems="center" flexDirection="column">
                  <FaShoppingBasket />
                  <Text color="white" fontSize="xs" mt={1}>
                      Market
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/restaurant-analytics">
                <Flex alignItems="center" flexDirection="column">
                <FaChartLine />
                <Text color="white" fontSize="xs" mt={1}>
                    Analytics
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-wallet">
                  <Flex alignItems="center" flexDirection="column">
                  <FaWallet />
                  <Text color="white" fontSize="xs" mt={1}>
                      Wallet
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-trades">
                  <Flex alignItems="center" flexDirection="column">
                  <FaExchangeAlt />
                  <Text color="white" fontSize="xs" mt={1}>
                      Trades
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-notifications">
                  <Flex alignItems="center" flexDirection="column">
                  <FaBell />
                  <Text color="white" fontSize="xs" mt={1}>
                      Notifications
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-settings">
                  <Flex alignItems="center" flexDirection="column">
                  <FaCog />
                  <Text color="white" fontSize="xs" mt={1}>
                      Settings
                  </Text>
                  </Flex>
              </Link>
            </Box>   
        </Flex>
        
    </Box>
  );
};

export default RestaurantMarketPlace;
